import { Skeleton, Stack, Typography } from '@mui/material';
import { PriceSuggestionType } from '@retail/products/types';
import { PriceTypesSelection } from './PriceTypesSelection';
import { useCalculusTFunction } from '@retail/calculus/i18n';

interface Props {
  priceSuggestionTypes: PriceSuggestionType[];
  checkedPriceTypes: PriceSuggestionType[];
  includeMarkup: boolean;
  isLoadingFetchPriceSuggestions: boolean;
  checkPriceType: (priceType: PriceSuggestionType) => void;
  getPriceTypeValue: (value: PriceSuggestionType) => string;
}

export function SalesPriceConditionPrioOptions({
  priceSuggestionTypes,
  checkedPriceTypes,
  includeMarkup,
  isLoadingFetchPriceSuggestions,
  checkPriceType,
  getPriceTypeValue,
}: Props) {
  const t = useCalculusTFunction();

  return (
    <Stack>
      <Stack height={50} justifyContent="center" px={2} bgcolor="action.hover">
        <Typography variant="subtitle2">
          {t('calculus.salesPriceCondition.availableSalesPriceConditions')}
        </Typography>
      </Stack>
      <Stack px={3} py={1}>
        {isLoadingFetchPriceSuggestions ? (
          <Skeleton />
        ) : (
          <PriceTypesSelection
            priceSuggestionTypes={priceSuggestionTypes}
            checkedPriceTypes={checkedPriceTypes}
            includeMarkup={includeMarkup}
            checkPriceType={checkPriceType}
            getPriceTypeValue={getPriceTypeValue}
          />
        )}
      </Stack>
    </Stack>
  );
}
